import useSWR from 'swr';

import Experiment from '@models/Experiment';
import { ExperimentData } from '@models/ExperimentData';

import Endpoints, { DEFAULT_PAGE_LIMIT } from '@services/Endpoints';

export type SampleData = ExperimentData<Record<string, string | number | null>> | undefined;
type Props = { experiment: Experiment | null | undefined; refreshInterval?: number };
const useSampleData = ({ experiment, refreshInterval }: Props) => {
    const experimentId = experiment?.uuid;
    const { data, error, ...swrStuff } = useSWR<SampleData>(
        () =>
            experimentId ? Endpoints.lab.experiment.sampleData({ experimentId }, { limit: DEFAULT_PAGE_LIMIT }) : null,
        { refreshInterval },
    );

    const loading = !data && !error;

    return { data, error, loading, ...swrStuff };
};

export default useSampleData;
